/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to mark activity as seen
 * @export
 * @interface MarkSeenRequest
 */
export interface MarkSeenRequest {
    /**
     * Event ID to mark as the user's cursor
     * @type {number}
     * @memberof MarkSeenRequest
     */
    lastSeenEventId: number;
}

/**
 * Check if a given object implements the MarkSeenRequest interface.
 */
export function instanceOfMarkSeenRequest(value: object): value is MarkSeenRequest {
    if (!('lastSeenEventId' in value) || value['lastSeenEventId'] === undefined) return false;
    return true;
}

export function MarkSeenRequestFromJSON(json: any): MarkSeenRequest {
    return MarkSeenRequestFromJSONTyped(json, false);
}

export function MarkSeenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkSeenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSeenEventId': json['lastSeenEventId'],
    };
}

export function MarkSeenRequestToJSON(json: any): MarkSeenRequest {
    return MarkSeenRequestToJSONTyped(json, false);
}

export function MarkSeenRequestToJSONTyped(value?: MarkSeenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastSeenEventId': value['lastSeenEventId'],
    };
}

